/* eslint-disable i18next/no-literal-string */
import classnames from "classnames";
import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React from "react";
import styles from "./devider.module.scss";
import type { DeviderProps } from "@whatslly/types/UI-V2/DeviderType";
import globalStyles from "../../v2/globalStyles";

export const Devider: React.FC<DeviderProps> = observer(({ ...props }) => {
  return (
    <div
      className={classnames(
        styles.deviderContainer,
        globalStyles[`pi-${props.paddingInline ?? "default"}`],
        globalStyles[`mb-${props.marginBottom ?? "default"}`],
        globalStyles[`mt-${props.marginTop ?? "none"}`]
      )}
    >
      <hr className={classNames(styles.devider)} />
    </div>
  );
});
